import ky from 'ky';
import { RootStateOrAny, useSelector } from 'react-redux';
import useCommonRequestOptions from '../useCommonRequestOptions';
import { CheckPhoneNumberExistsPayload, RegisterUserPayload, VerifyEmailPayload } from '../../library/interfaces';

type TRegisterUserResponse = {
  success: boolean;
  accessToken: string;
  refreshToken: string;
  updatedRegisterToken: string;
  userId: string;
};
export default function useUser() {
  const token = useSelector((state: RootStateOrAny) => state.auth.accessToken);
  const { getCommonRequestOptions } = useCommonRequestOptions();

  async function checkPhoneNumberExists(
    payload: CheckPhoneNumberExistsPayload
  ): Promise<{ invalid: boolean; isExistingUser: boolean; phoneNumber: string; regionCode: string; message?: string }> {
    return ky
      .post('phone/exists', { ...getCommonRequestOptions('user', { useBasicAuth: true }), json: payload })
      .json();
  }

  async function registerUser(payload: RegisterUserPayload, registerToken: string): Promise<TRegisterUserResponse> {
    return ky
      .post('register', { ...getCommonRequestOptions('user', { token: registerToken, retry: false }), json: payload })
      .json();
  }

  async function verifyEmailExists(
    payload: VerifyEmailPayload
  ): Promise<{ isExistingUser: boolean; phoneNumber: string; regionCode: string }> {
    return ky
      .post('email/exists', { ...getCommonRequestOptions('user', { useBasicAuth: true }), json: payload })
      .json();
  }

  async function sendMeALink(authToken: string) {
    return ky.post('send-link', { ...getCommonRequestOptions('user', { token: authToken }) }).json();
  }
  async function getUserDetailsByDevice(deviceId: string): Promise<any> {
    return ky
      .get(`userDetails/${deviceId}`, {
        ...getCommonRequestOptions('user', { useBasicAuth: true }),
      })
      .json();
  }

  return {
    checkPhoneNumberExists,
    registerUser,
    verifyEmailExists,
    sendMeALink,
    getUserDetailsByDevice,
  };
}
